import Header from '@/components/feature/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <CarouselSection />
        <TopicsSection />
        <CommentsSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}